import type { SignatureBlock } from '@blogforge/shared';

// Canvas preview for the signature block. Mirrors the email renderer's
// spam-safe design: the name/title are real text, images carry alt text.
export function SignatureRenderer({ block }: { block: SignatureBlock }) {
  const { name, title, company, avatarSrc, avatarAlt, logoSrc, logoAlt, socials, variant, layout } =
    block.attrs;
  const center = layout === 'center';

  const avatar = avatarSrc ? (
    <img
      className="h-14 w-14 flex-shrink-0 rounded-full object-cover"
      src={avatarSrc}
      alt={avatarAlt || name}
    />
  ) : null;

  const logo = logoSrc ? (
    <img className="max-h-12 w-auto" src={logoSrc} alt={logoAlt || ''} />
  ) : null;

  return (
    <div
      className={`flex items-center gap-4 rounded-lg p-4 ${
        variant === 'card' ? 'doc-border doc-surface border' : ''
      } ${center ? 'flex-col text-center' : ''}`}
    >
      {logo}
      {avatar}
      <div>
        <div className="doc-text font-semibold">{name}</div>
        {title || company ? (
          <div className="doc-muted mt-0.5 text-sm">
            {[title, company].filter(Boolean).join(' · ')}
          </div>
        ) : null}
        {socials?.length > 0 ? (
          <div className="mt-2 text-sm">
            {socials.map((s) => (
              <a
                key={s.platform}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="doc-link mr-3"
              >
                {s.platform}
              </a>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
